"use client";

import { useState } from "react";
import { useFaqs } from "../context/FaqContext";

export default function Faqs() {
  const { faqs, loading, error } = useFaqs();
  const [openId, setOpenId] = useState(null);

  const toggleFaq = (id) => {
    setOpenId(openId === id ? null : id);
  };

  if (loading) {
    return (
      <section className="py-12 text-center text-gray-600">
        Loading FAQs...
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-12 text-center text-red-500">
        {error}
      </section>
    );
  }

  return (
    <section className="pb-10 pt-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Heading */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-gray-800 mb-8"
        style={{ fontFamily: "Gloock, serif" }}
        >
          Frequently Asked Questions
        </h2>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs
            .filter((faq) => faq.status === "Active")
            .map((faq) => (
              <div
                key={faq.id}
                className="w-full bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
              >
                {/* Question */}
                <button
                  onClick={() => toggleFaq(faq.id)}
                  className="w-full flex justify-between items-center p-5 text-left hover:bg-gray-50 transition-colors duration-200 "
                  aria-expanded={openId === faq.id}
                  aria-controls={`faq-answer-${faq.id}`}
                >
                  <span className="text-base sm:text-lg font-medium text-gray-800 pr-4 flex-1">
                    {faq.question}
                  </span>
                  <span className="text-xl font-bold text-gray-500 flex-shrink-0 transition-transform duration-200">
                    {openId === faq.id ? "−" : "+"}
                  </span>
                </button>

                {/* Answer */}
                <div
                  id={`faq-answer-${faq.id}`}
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-5 text-sm sm:text-base text-gray-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
